<template>
  <div class="wishlist-page pb-12">
    <PageLoader v-bind:storage="appLoading" v-bind:contain="true" />
    <ServerError v-if="ServerError" />
    
    <v-snackbar v-model="showSnackBar" color="#3EA56E" right :timeout="timeout" class="mt-12">
      <div class="d-flex align-center">
        <v-icon color="white" class="mr-2">mdi-check-circle</v-icon>
        <span class="ibmmedium">{{ msg }}</span>
        <v-spacer></v-spacer>
        <v-btn icon small @click="showSnackBar = false">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </div>
    </v-snackbar>

    <v-container class="mt-8 mt-md-4 pt-4 pt-md-0">
      <v-layout wrap>
        <!-- Header Section -->
        <v-flex xs12 class="mb-8">
          <div class="d-flex align-center">
            <v-icon color="#3EA56E" class="mr-3" size="28">mdi-heart-outline</v-icon>
            <h1 class="page-title">My Wishlist</h1>
          </div>
          <v-divider class="title-divider mt-2"></v-divider>
        </v-flex>

        <!-- Wishlist Content -->
        <v-flex xs12 v-if="wishlist.length > 0">
          <v-layout wrap>
            <v-flex xs12 md12 v-for="(item, i) in wishlist" :key="i" class="mb-4">
              <v-card flat class="wishlist-card">
                <v-layout wrap align-center class="pa-4">
                  <!-- Product Image -->
                  <v-flex xs12 sm3 md2 class="pr-sm-4 mb-4 mb-sm-0 text-center">
                    <div class="image-container">
                      <template v-if="item.product.photos && item.product.photos.length > 0">
                        <v-img
                          :src="mediaURL + item.product.photos[0]"
                          class="product-image rounded-lg"
                          height="140"
                          contain
                          @click="$router.push('/productdetailview/' + item.product.urlname)"
                        >
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-progress-circular indeterminate color="#3EA56E"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </template>
                      <template v-else>
                        <v-img
                          :src="require('../../../assets/noimg.png')"
                          class="product-image rounded-lg"
                          height="140"
                          contain
                          @click="$router.push('/productdetailview/' + item.product.urlname)"
                        ></v-img>
                      </template>
                      <div class="out-of-stock-overlay d-flex align-center justify-center" v-if="item.product.status == 'Inactive'">
                        <span class="out-of-stock-badge">OUT OF STOCK</span>
                      </div>
                    </div>
                  </v-flex>

                  <!-- Product Info -->
                  <v-flex xs12 sm5 md6>
                    <div class="product-info-section text-center text-sm-left">
                      <h3 class="product-name mb-1" @click="$router.push('/productdetailview/' + item.product.urlname)">
                        {{ item.product.productname }}
                      </h3>
                      <div class="price-section d-flex align-center justify-center justify-sm-start mb-2">
                        <span class="offer-price">₹{{ item.product.offerPrice }}</span>
                        <span class="original-price ml-2">₹{{ item.product.price }}</span>
                      </div>
                    </div>
                  </v-flex>

                  <!-- Action Buttons -->
                  <v-flex xs12 sm4 md4>
                    <div class="action-section d-flex flex-column">
                      <v-btn
                        depressed
                        block
                        color="#3EA56E"
                        class="action-btn add-to-cart mb-2"
                        :disabled="item.product.status == 'Inactive'"
                        :loading="wishlistLoading"
                        @click="add(item.product._id, item.quantity)"
                      >
                        <v-icon left size="18">mdi-cart-plus</v-icon>
                        Add to Cart
                      </v-btn>
                      
                      <v-btn
                        text
                        block
                        class="action-btn remove-btn"
                        :loading="wishlistLoading"
                        @click="removeFromWishlist(item.product._id)"
                      >
                        <v-icon left size="18">mdi-delete-outline</v-icon>
                        Remove from Wishlist
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>

        <!-- Empty State -->
        <v-flex xs12 v-else-if="!appLoading" class="text-center py-16 mt-8">
          <div class="empty-state-container">
            <v-icon size="80" color="#e2e8f0" class="mb-4">mdi-heart-plus-outline</v-icon>
            <h2 class="empty-title mb-2">Your wishlist is empty</h2>
            <p class="empty-description mb-8">Save items you like in your wishlist. Review them anytime and easily move them to the cart.</p>
            <v-btn
              color="#3EA56E"
              dark
              depressed
              to="/products"
              class="explore-btn px-10 py-6"
            >
              Start Shopping
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
// import WishlistItem from "./wishlistItem";
export default {
  // components: {
  //   WishlistItem,
  // },
  data() {
    return {
      appLoading: false,
      wishlistLoading: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      wishlist: [],
      products: [],
      ServerError: false,
    };
  },
  beforeMount() {
    this.setMetaTags();
    this.getData();
  },
  methods: {
    setMetaTags() {
      document.title = "My Wishlist | KL-06 FARM";
      let metaDescription = document.querySelector('meta[name="description"]');
      const description = "View and manage your saved favorite products at KL-06 FARM.";
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      } else {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        metaDescription.content = description;
        document.head.appendChild(metaDescription);
      }
    },
    getData() {
      this.appLoading = true;
      var headers1 = {};
      var data = {};
      
      if (this.$store.state.isLoggedIn) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      } else {
        data["guestid"] = localStorage.getItem("guestId");
      }

      axios({
        method: "GET",
        url: "/WishList/all",
        headers: headers1,
        params: data,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.wishlist = response.data.wishlist;
          } else {
            this.products = [];
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    removeFromWishlist(item) {
      var product = {};
      product["productid"] = item;
      this.wishlistLoading = true;

      var headers1 = {};
      if (this.$store.state.isLoggedIn) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      } else {
        product["guestid"] = localStorage.getItem("guestId");
      }

      axios({
        method: "POST",
        url: "/WishList/Remove",
        data: product,
        headers: headers1,
      })
        .then((response) => {
          this.wishlistLoading = false;
          this.$store.commit("changeWishlist", response.data.wishlistcount);
          this.msg = response.data.msg;
          this.showSnackBar = true;
          // this.getData();
          window.location.reload();

          this.productData.isinwishlist = false;
          // this.msg = response.data.msg;
          // this.showSnackBar = true;
        })
        .catch((err) => {
          this.wishlistLoading = false;
          console.log(err);
        });
    },
    add(item, qty1) {
      var data = {
        productId: item,
        quantity: qty1,
      };
      
      var headers1 = {};
      if (this.$store.state.isLoggedIn) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      } else {
        data["guestid"] = localStorage.getItem("guestId");
      }

      axios({
        method: "post",
        url: "/cart/add",
        headers: headers1,
        data: data,
      })
        .then((response) => {
          if (response.data.status == true) {
            this.snackbar = true;
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.$store.commit("changeCart", response.data.cartLength);
            // this.getData();
            window.location.reload();
            // this.$router.push("/cart");
            // setTimeout(() => this.$router.go(), 3000);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
            this.showSnackBar = true;
            // if (this.snackbar == false) {
            //   this.$router.go();
            // }
            // setTimeout(() => this.$router.go(), 3000);
          }
          // this.getData();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // winStepper(item) {
    //   if (item.ref == "remove") {
    //     this.msg = item.response.msg;
    //     this.showSnackBar = true;
    //     if (item.getData) {
    //       this.getData();
    //     }
    //   }
    // },
  },
};
</script>
<style scoped>
.wishlist-page {
  background-color: #f8fafc;
  min-height: 100vh;
}

.page-title {
  font-family: "ibmsemibold", sans-serif;
  font-size: 24px;
  color: #1a202c;
  margin: 0;
}

.title-divider {
  border-color: #e2e8f0;
  max-width: 80px;
  border-width: 2px;
}

.wishlist-card {
  border: 1px solid #e2e8f0;
  border-radius: 16px !important;
  transition: all 0.3s ease;
  background-color: #ffffff;
}

.wishlist-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);
  border-color: #3EA56E;
}

.product-image {
  cursor: pointer;
  transition: transform 0.3s ease;
}

.product-image:hover {
  transform: scale(1.05);
}

.product-name {
  font-family: "ibmsemibold", sans-serif;
  font-size: 18px;
  color: #2d3748;
  cursor: pointer;
  transition: color 0.2s ease;
}

.product-name:hover {
  color: #3EA56E;
}

.offer-price {
  font-family: "ibmsemibold", sans-serif;
  font-size: 20px;
  color: #3EA56E;
}

.original-price {
  font-family: "sofialight", sans-serif;
  font-size: 14px;
  color: #94a3b8;
  text-decoration: line-through;
}

.action-btn {
  font-family: "ibmsemibold", sans-serif;
  text-transform: none;
  letter-spacing: 0.5px;
  border-radius: 8px !important;
  height: 48px !important;
}

.add-to-cart {
  color: white !important;
}

.remove-btn {
  color: #ef4444 !important;
}

.remove-btn:hover {
  background-color: #fee2e2 !important;
}

.empty-title {
  font-family: "ibmsemibold", sans-serif;
  font-size: 24px;
  color: #334155;
}

.empty-description {
  font-family: "sofialight", sans-serif;
  font-size: 16px;
  color: #64748b;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

.explore-btn {
  font-family: "ibmsemibold", sans-serif;
  text-transform: none;
  font-size: 16px;
  border-radius: 12px !important;
}

.image-container {
  position: relative;
  overflow: hidden;
}

.out-of-stock-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 2;
}

.out-of-stock-badge {
  background-color: #ef4444;
  color: white;
  padding: 4px 12px;
  font-family: "ibmsemibold", sans-serif;
  font-size: 10px;
  border-radius: 4px;
  letter-spacing: 1px;
}

.ibmmedium {
  font-family: "ibmmedium", sans-serif;
}

@media (max-width: 600px) {
  .page-title {
    font-size: 20px;
  }
  .product-name {
    font-size: 16px;
  }
  .offer-price {
    font-size: 18px;
  }
}
</style>